import React, { useState, useEffect } from "react";
import "./MultiSwitch.scss";

const MultiSwitch = ({options, defaultOption, setOption, type}) => {
    const [selected, setSelected] = useState(defaultOption);

    useEffect(() => {
      setSelected(defaultOption);
    }, [defaultOption]);

    return (
      <div className={"multi-switch " + type}>
        {options.map((option, index) => (
          <div 
            key={index}
            className={`option ${selected === index ? "selected" : ""}`}
            onClick={() => {setSelected(index); setOption(index);}}
          >
            {option}
          </div>
        ))}
        <div 
          className="slider" 
          style={{ 
            left: `calc(${selected * 100 / options.length}%)`,
            width: `calc(${100 / options.length}%)`
          }}
        />
      </div>
    );
};

export default MultiSwitch;